import classNames from "../../../utils/classNames"

export const NumberInput = ({ label, register, registerName, placeholder = "", step = ".01", classes = "", size = "md", disabled = false }) => {

  const sizeClasses = {
    sm: "px-2 py-1 text-sm",
    md: "px-3 py-2 text-sm",
    lg: "px-4 py-3 text-base"
  }

  return (
    <div className={classNames(classes, "sm:col-span-1")}>
      <label className="text-sm font-medium text-gray-500">{label}</label>
      <input
        {...register(registerName)}
        disabled={disabled}
        type="number"
        step={step}
        placeholder={placeholder}
        className={classNames(
          disabled ? "bg-gray-300" : "",
          `w-full mt-1 text-gray-900 border-1 border-gray-400 ${sizeClasses[size]}`
        )}
      />
    </div>
  )
}